import { FrameworkScope, useLiveData } from '@toeverything/infra';
import { useLayoutEffect, useMemo } from 'react';
import type { RouteObject } from 'react-router-dom';
import {
  createMemoryRouter,
  RouterProvider,
  UNSAFE_LocationContext,
  UNSAFE_RouteContext,
} from 'react-router-dom';

import type { View } from '../entities/view';

export const ViewRoot = ({
  view,
  routes,
}: {
  view: View;
  routes: RouteObject[];
}) => {
  const viewRouter = useMemo(() => {
    const initialLocation = view.location$.value;
    console.log('aaaaaaaaahhhhinitialLocation', initialLocation, routes);
    return createMemoryRouter(routes, {
      initialEntries: [
        {
          pathname: initialLocation.pathname,
          search: initialLocation.search,
          hash: initialLocation.hash,
          state: initialLocation.state,
        },
      ],
      initialIndex: 0,
    });
  }, [routes, view]);

  const location = useLiveData(view.location$);

  useLayoutEffect(() => {
    const currentRouterLocation = viewRouter.state.location;
    // 只在真正不同时才导航，避免不必要的重渲染
    // if (
    //   location.pathname === currentRouterLocation.pathname &&
    //   location.search === currentRouterLocation.search &&
    //   location.hash === currentRouterLocation.hash
    // ) {
    //   return;
    // }
    viewRouter.navigate(location).catch(err => {
      console.error('navigate error', err);
    });
  }, [location, viewRouter]);

  // https://github.com/remix-run/react-router/issues/7375#issuecomment-975431736
  return (
    <FrameworkScope scope={view.scope}>
      <UNSAFE_LocationContext.Provider value={null as any}>
        <UNSAFE_RouteContext.Provider
          value={{
            outlet: null,
            matches: [],
            isDataRoute: false,
          }}
        >
          <RouterProvider router={viewRouter} />
        </UNSAFE_RouteContext.Provider>
      </UNSAFE_LocationContext.Provider>
    </FrameworkScope>
  );
};
